import React, { useEffect, useState } from 'react';
import { Link, useFetcher } from "react-router-dom";

import { useDispatch, useSelector } from 'react-redux';
import { open, close, reset } from '../redux/popupSlice';


import Button from '../component/Button';

//import images from '../libs/images';


export default function Popup({}) {

    const dispatch = useDispatch();
    const { 
        open, title, titleStyle, content, contentbold, button, buttonCencle, 
        onCancelPress, onPress, alert, alertStyle, component, componentExit, style, 
        wideOne, titleviewer, buttonviewer
    } = useSelector(s => s.popupReducer);


    const handleClose = () => {
        dispatch(close());
        onCancelPress && onCancelPress();
    };

    const handleSubmit = () => {
        dispatch(close());
        onPress && onPress();
    };

    return (
        <>
        {open &&
            <div className='PopupArea' >
                <div>
                    <div className='PopupAreaBG' 
                        //onClick={() => dispatch(close())}
                    />
                    <div className='PopupAreaContents' style={ alertStyle && alertStyle}>
                        <div>
                            {titleviewer === true &&
                            <div className="popTitle padding20">
                                <span >{title}</span>
                                <button
                                    onClick={() => {
                                        dispatch(close())
                                    }}
                                >
                                    <img src="./images/icons/x.svg" width='20' />                                            
                                </button>
                            </div>
                            }
                            {wideOne === false && 
                            <div className="padding32">
                                {content && <div className='popcontents'>{content}</div>}
                                {component && <div className='popcontents' style={{ whiteSpace: 'pre-wrap'}}>{component}</div>}
                                {(onCancelPress || onPress) && 
                                <div className='popbuttons'>
                                    {onCancelPress && 
                                        <div>
                                            <Button
                                                disabled={true}
                                                buttonTxt={buttonCencle}
                                                onPress={() => { onCancelPress(); }}
                                            />                                    
                                        </div>
                                    }
                                    {onPress &&
                                        <div style={titleviewer === false ? { width: '100%'} : {}}>
                                            <Button
                                                buttonTxt={button}
                                                onPress={() => { onPress(); }}
                                            />                                    
                                        </div>
                                    }
                                </div>
                                }
                            </div>
                            }
                            {wideOne === true && 
                                <>
                                <div className="padding20">
                                    {content && <div className='popcontents'>{content}</div>}
                                    {component && <div className='popcontents'>{component}</div>}
                                </div>
                                                                
                                <div>
                                    <Button
                                        buttonTxt={button}
                                        onPress={() => { onPress(); }}
                                        styles={{ height: 52, borderTopLeftRadius: 0, borderTopRightRadius: 0 }}
                                    />                                    
                                </div>    
                                </>                        
                            }
                        </div>
                    </div>
                </div>
    
            </div>
        }
        </>
    );
}
